import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { AlertType, TextStyleProp } from './types';

export const getBorderLeftColor = (type: AlertType) => {
  if (type === 'error') return theme.colors.status.critical;
  if (type === 'info') return theme.colors.primary50;
  if (type === 'success') return theme.colors.status.success;
  else return theme.colors.status.warning;
};

export const getAlertTextTheme = ({ type }: TextStyleProp) => ({
  spacing: theme.spacing,
  borderLeftColor: getBorderLeftColor(type),
  borderRadius: theme.borderRadius.medium,
});

export const textStyle = (type: AlertType) => css`
  display: flex;
  align-items: center;
  margin: 0;

  ::before {
    content: '';
    width: 4px;
    height: 100%;

    background: ${getBorderLeftColor(type)};
    border-top-left-radius: ${theme.borderRadius.medium};
    border-bottom-left-radius: ${theme.borderRadius.medium};
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }

  svg {
    min-width: 24px;
    margin-right: ${theme.spacing(1)};
  }
`;

export const containerStyle = css`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.heavy};
  width: 100%;
  overflow: hidden;
  display: flex;
  position: relative;
  pointer-events: all;
  z-index: ${theme.zIndex.low};
`;

export const alertActionContainerStyle = css`
  border-left: 1px solid ${theme.colors.neutral50};
  padding: ${theme.spacing(0, 2)};
  margin-left: auto;
  display: flex;
  align-items: center;
  margin: ${theme.spacing(2, 0)};
`;

const sizeValue = '24px';

export const closeButtonStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  min-width: ${sizeValue};
  width: ${sizeValue};
  min-height: ${sizeValue};
  height: ${sizeValue};
  border-radius: 50px;
  padding: 0;
  font-size: initial;
  pointer-events: all;
  cursor: pointer;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.heavy};
`;
